"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardScene = void 0;
var TutorialLayer_1 = require("./layers/TutorialLayer");
var NewBadgeLayer_1 = require("./layers/NewBadgeLayer");
var NewAreaLayer_1 = require("./layers/NewAreaLayer");
var RestartLayer_1 = require("./layers/RestartLayer");
var WelcomeBackLayer_1 = require("./layers/WelcomeBackLayer");
var GameManager_1 = require("../../GameManager");
var HUD_1 = require("./hud/HUD");
var GUI_1 = require("./gui/GUI");
var BoardManager_1 = require("./BoardManager");
var BoardContainer_1 = require("./board/BoardContainer");
var GameVars_1 = require("../../GameVars");
var ScrollingLayer_1 = require("./layers/ScrollingLayer");
var Background_1 = require("../Background");
var GameConstants_1 = require("../../GameConstants");
var NewItemLayer_1 = require("./layers/NewItemLayer");
var LevelUpLayer_1 = require("./layers/LevelUpLayer");
var NewGameModeLayer_1 = require("./layers/NewGameModeLayer");
var EmptySpacesLayer_1 = require("./layers/EmptySpacesLayer");
var AudioManager_1 = require("../../AudioManager");
var BoardScene = /** @class */ (function (_super) {
    __extends(BoardScene, _super);
    function BoardScene() {
        var _this = _super.call(this, "BoardScene") || this;
        BoardScene.currentInstance = _this;
        return _this;
    }
    BoardScene.prototype.preload = function () {
        if (GameVars_1.GameVars.gameData.tutorialPhase === 1) {
            this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        }
    };
    BoardScene.prototype.create = function () {
        GameManager_1.GameManager.setCurrentScene(this);
        BoardManager_1.BoardManager.init();
        var background = new Background_1.Background(this);
        this.add.existing(background);
        this.boardContainer = new BoardContainer_1.BoardContainer(this);
        this.add.existing(this.boardContainer);
        this.hud = new HUD_1.HUD(this);
        this.add.existing(this.hud);
        this.gui = new GUI_1.GUI(this);
        this.add.existing(this.gui);
        this.achievementsLayer = new ScrollingLayer_1.ScrollingLayer(this, GameConstants_1.GameConstants.ACHIEVEMENTS);
        this.add.existing(this.achievementsLayer);
        this.newItemLayer = null;
        this.levelUpLayer = null;
        this.emptySpacesLayer = null;
        this.newGameModeLayer = null;
        if (GameVars_1.GameVars.needShowNewBudget) {
            BoardManager_1.BoardManager.showNewBadgeLayer();
        }
        else {
            var fontSize = this.game.device.input.touch ? 13 : 18;
            var copyrightLabel_1 = this.add.text(6, 6 * GameVars_1.GameVars.scaleY, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language].DEVELOPED_BY + " ravalmatic\n" + GameVars_1.GameVars.gameText[GameVars_1.GameVars.language].LICENSED_TO + "Game Distribution", { fontFamily: "Arial", fontSize: fontSize + "px", color: "#6331b3" });
            copyrightLabel_1.setOrigin(0);
            copyrightLabel_1.scaleY = GameVars_1.GameVars.scaleY;
            this.tweens.add({
                targets: copyrightLabel_1,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 450,
                delay: 15000,
                onComplete: function () {
                    copyrightLabel_1.destroy();
                },
                onCompleteScope: this
            });
            BoardManager_1.BoardManager.showWelcomeBackLayer();
            AudioManager_1.AudioManager.playSound(GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "cake_house_soundtrack" : "pastry_saloon_soundtrack", true);
        }
        // las animaciones
        this.anims.create({
            key: "merge-fx",
            frames: this.anims.generateFrameNames("texture_atlas_1", { prefix: "fx_merge_", start: 1, end: 19, zeroPad: 2 }),
            frameRate: 20
        });
        this.anims.create({
            key: "uncover-fx",
            frames: this.anims.generateFrameNames("texture_atlas_1", { prefix: "fx_particles_radial_", start: 1, end: 23, zeroPad: 2 }),
            frameRate: 26
        });
        this.anims.create({
            key: "gem-fx",
            frames: this.anims.generateFrameNames("texture_atlas_1", { prefix: "fx_particles_vertical", start: 1, end: 23, zeroPad: 2 }),
            frameRate: 26
        });
        GameManager_1.GameManager.updateLastPlayerAction();
        if (GameVars_1.GameVars.gameData.tutorialPhase === 1) {
            this.tutorialLayer = new TutorialLayer_1.TutorialLayer(this);
            this.add.existing(this.tutorialLayer);
            this.gui.setVisible(false);
            this.hud.visible = false;
            GameVars_1.GameVars.paused = true;
        }
        this.cameras.main.fadeIn(300, 255, 255, 255);
        GameManager_1.GameManager.loadRewardedAd();
    };
    BoardScene.prototype.startTutorialPhase2 = function () {
        this.tutorialLayer.startTutorialPhase2();
    };
    BoardScene.prototype.startTutorialPhase3 = function () {
        this.tutorialLayer.startTutorialPhase3();
    };
    BoardScene.prototype.startTutorialPhase4 = function () {
        this.tutorialLayer.visible = false;
    };
    BoardScene.prototype.startTutorialPhase5 = function () {
        this.tutorialLayer.startTutorialPhase5();
        this.gui.showClicksCounter();
    };
    BoardScene.prototype.onTutorialDone = function () {
        this.gui.onTutorialDone();
        this.hud.visible = true;
        this.tutorialLayer.destroy();
    };
    BoardScene.prototype.update = function () {
        BoardManager_1.BoardManager.update();
        this.gui.update();
        this.boardContainer.update();
        if (this.shopLayer) {
            this.shopLayer.update();
        }
        if (this.achievementsLayer.visible) {
            this.achievementsLayer.update();
        }
    };
    BoardScene.prototype.showNewGameModeLayer = function () {
        this.newGameModeLayer = new NewGameModeLayer_1.NewGameModeLayer(this);
        this.add.existing(this.newGameModeLayer);
    };
    BoardScene.prototype.updateCoinsCounters = function () {
        this.hud.updateCoinsCounters();
    };
    BoardScene.prototype.markAchievements = function () {
        this.gui.markButton(GameConstants_1.GameConstants.ACHIEVEMENTS);
    };
    BoardScene.prototype.unmarkAchievements = function () {
        this.gui.unmarkButton(GameConstants_1.GameConstants.ACHIEVEMENTS);
    };
    BoardScene.prototype.markShop = function () {
        this.gui.markButton(GameConstants_1.GameConstants.SHOP);
    };
    BoardScene.prototype.unmarkShop = function () {
        this.gui.unmarkButton(GameConstants_1.GameConstants.SHOP);
    };
    BoardScene.prototype.onItemPurchased = function () {
        this.hud.updateCoinsCounters();
    };
    BoardScene.prototype.onItemsMerged = function () {
        this.boardContainer.onItemsMerged();
    };
    BoardScene.prototype.updateStartsContainer = function () {
        this.hud.updateStarsContainer();
    };
    BoardScene.prototype.showScrollingLayer = function (name) {
        if (name === GameConstants_1.GameConstants.SHOP) {
            if (!this.shopLayer) {
                this.shopLayer = new ScrollingLayer_1.ScrollingLayer(this, GameConstants_1.GameConstants.SHOP);
                this.shopLayer.visible = true;
                ScrollingLayer_1.ScrollingLayer.canBeClosed = true;
                this.add.existing(this.shopLayer);
            }
        }
        else {
            this.achievementsLayer.appear();
        }
    };
    BoardScene.prototype.hideScrollingLayer = function () {
        if (this.shopLayer) {
            this.shopLayer.destroy();
            this.shopLayer = null;
        }
        else {
            this.achievementsLayer.disappear();
        }
    };
    BoardScene.prototype.showWelcomeBackLayer = function () {
        this.welcomeBackLayer = new WelcomeBackLayer_1.WelcomeBackLayer(this);
        this.add.existing(this.welcomeBackLayer);
    };
    BoardScene.prototype.hideWelcomeBackLayer = function () {
        this.welcomeBackLayer.destroy();
        this.welcomeBackLayer = null;
    };
    BoardScene.prototype.showRestartLayer = function () {
        this.restartLayer = new RestartLayer_1.RestartLayer(this);
        this.add.existing(this.restartLayer);
    };
    BoardScene.prototype.hideRestartLayer = function () {
        this.restartLayer.destroy();
        this.restartLayer = null;
    };
    BoardScene.prototype.showNewBadgeLayer = function () {
        this.newBadgeLayer = new NewBadgeLayer_1.NewBadgeLayer(this);
        this.add.existing(this.newBadgeLayer);
    };
    BoardScene.prototype.hideNewBadgeLayer = function () {
        this.newBadgeLayer.destroy();
        this.newBadgeLayer = null;
    };
    BoardScene.prototype.showNewItemLayer = function () {
        this.newItemLayer = new NewItemLayer_1.NewItemLayer(this);
        this.add.existing(this.newItemLayer);
    };
    BoardScene.prototype.hideNewItemLayer = function () {
        this.newItemLayer.destroy();
        this.newItemLayer = null;
    };
    BoardScene.prototype.showNewAreaLayer = function () {
        this.newAreaLayer = new NewAreaLayer_1.NewAreaLayer(this);
        this.add.existing(this.newAreaLayer);
    };
    BoardScene.prototype.hideNewAreaLayer = function () {
        this.newAreaLayer.destroy();
        this.newAreaLayer = null;
        this.gui.showGameModeButtons();
    };
    BoardScene.prototype.showLevelUpLayer = function () {
        this.levelUpLayer = new LevelUpLayer_1.LevelUpLayer(this);
        this.add.existing(this.levelUpLayer);
    };
    BoardScene.prototype.hideLevelUpLayer = function () {
        this.levelUpLayer.destroy();
        this.levelUpLayer = null;
    };
    BoardScene.prototype.removeNewGameModeLayer = function () {
        this.newGameModeLayer.destroy();
        this.newGameModeLayer = null;
    };
    BoardScene.prototype.showEmptySpacesLayer = function () {
        if (this.emptySpacesLayer) {
            return;
        }
        this.emptySpacesLayer = new EmptySpacesLayer_1.EmptySpacesLayer(this);
        this.add.existing(this.emptySpacesLayer);
    };
    BoardScene.prototype.hideEmptySpacesLayer = function () {
        this.emptySpacesLayer.destroy();
        this.emptySpacesLayer = null;
    };
    BoardScene.prototype.showRestartButton = function () {
        this.gui.showRestartButton();
    };
    return BoardScene;
}(Phaser.Scene));
exports.BoardScene = BoardScene;
